import store from '@/store'

import { ErrorParams } from '../models/errorParams.model'

const useError = () => {
  const setError = (params: ErrorParams) => {
    store.dispatch('errors/setError', params)
  }

  return {
    setError
  }
}

export default useError
